import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { ISleepModeProps } from '../types';

export const SleepModeContext = React.createContext<ISleepModeProps>({
  setStartTime: () => null,
});

let interval: string | number | NodeJS.Timeout | undefined;

export function SleepModeProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [startTime, setStartTime] = React.useState<number | null>(null);

  const setStartTimeHandler = React.useCallback(
    (value: number) => setStartTime(value),
    [],
  );

  const startCountDown = (value: number) => {
    interval = setInterval(() => {
      const secondsPassed = Math.floor((Date.now() - value) / 1000);
      console.log({ secondsPassed });
      if (secondsPassed === 180) {
        navigate('idle');
        clearInterval(interval);
      }
    }, 1000);
  };

  React.useEffect(() => {
    clearInterval(interval);
    if (startTime) {
      startCountDown(startTime);
    }
    return () => {
      clearInterval(interval);
    };
  }, [startTime]);

  const context = React.useMemo(
    () => ({
      setStartTime: setStartTimeHandler,
    }),
    [setStartTimeHandler],
  );

  return (
    <SleepModeContext.Provider value={context}>
      {children}
    </SleepModeContext.Provider>
  );
}
